<dgx-components-grid-section>
  <dgx-components-grid-container class="text-align--{{ textAlign }} mt-12 p-8">
    <dgx-components-grid-row>
      <dgx-components-grid-column [xs]="12">
        <h1 *ngIf="title" class="pb-4">
          {{ title }}
        </h1>

        <p *ngIf="subtitle" class="pb-4 typog-body-large">{{ subtitle }}</p>

        <dgx-components-rich-text *ngIf="body" [content]="body" />
      </dgx-components-grid-column>
    </dgx-components-grid-row>
  </dgx-components-grid-container>
</dgx-components-grid-section>
